import React from 'react';
import { RatingPill } from '@noths/polaris-design-system-candidate-components';

import {
  formatNumberOfOrders,
  MINIMUM_NUMBER_OF_ORDERS_TO_DISPLAY,
} from 'src/components/molecules/PartnerMiniModule/utils/formatNumberOfOrders';
import { formatPartnerDuration } from 'src/components/molecules/PartnerMiniModule/utils/formatPartnerDuration';
import * as styles from './PartnerInfo.styles';

export const PARTNER_INFO_TEST_ID = 'PartnerMiniModule-partner-info';

export interface PartnerInfoProps {
  dateJoined?: string;
  numberOfOrders?: number;
  rating?: number;
}

const InfoItem = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <li css={styles.infoItem}>
    <span css={styles.infoItemValue}>{value}</span>
    <span>{label}</span>
  </li>
);

export const PartnerInfo = ({ dateJoined, numberOfOrders, rating }: PartnerInfoProps) => {
  const formattedOrders =
    numberOfOrders !== undefined && numberOfOrders >= MINIMUM_NUMBER_OF_ORDERS_TO_DISPLAY
      ? formatNumberOfOrders(numberOfOrders)
      : '';
  const showOrders = Boolean(formattedOrders);
  const showRating = rating !== undefined && rating >= 0;
  const durationLabel = formatPartnerDuration(dateJoined);

  if (!showOrders && !showRating && !durationLabel) {
    return null;
  }

  return (
    <ul css={styles.infoStrip} data-testid={PARTNER_INFO_TEST_ID}>
      {showOrders && <InfoItem label="Orders" value={formattedOrders} />}
      {showRating && <InfoItem label="Brand rating" value={<RatingPill rating={rating} />} />}
      {durationLabel && <InfoItem label="on NOTHS" value={durationLabel} />}
    </ul>
  );
};
